import { render } from "./my-page.vue?vue&type=template&id=7e57d93a"
import script from "./my-page.vue?vue&type=script&lang=js"
export * from "./my-page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__